import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MenuRole, Menu } from '../models/CommonModels';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private menuRoleUrl = environment.baseUrl + '/MenuRole';

  constructor(private http: HttpClient) { }

  addMenuRole(menuRole){
    return this.http.post<any>(this.menuRoleUrl ,menuRole);
  }

  unlinkMenuRole(id) {
    return this.http.delete<any>(this.menuRoleUrl + '/' + id);
  }

  getMenuByRole(roleID: number){
    return this.http.get<MenuRole[]>(this.menuRoleUrl + '/MenuByRole/' + roleID);
  }

  getMenus(){
    return this.http.get<Menu[]>(this.menuRoleUrl + '/GetMenus');
  }
}
